import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormRequest, NavigationService } from '../../../../modules/tcm-core.module';
import { UserDefaultInfoResponse } from '../../../../models/users';
import { BaseSecureDetails } from '../../../../modules/tcm-common';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { LoginApiService } from '../../../../services/system/login-api.service';

@Component({
    selector: 'user-default-info',
    templateUrl: './user-default-info.component.html',
    standalone: false
})
export class UserDefaultInfoComponent extends BaseSecureDetails<FormRequest, UserDefaultInfoResponse>{    

    constructor(protected override componentContext: SecureBaseComponentContext,
        protected override route: ActivatedRoute,
        private readonly navigator: NavigationService,
        private readonly loginService: LoginApiService) {
        super(componentContext, route);
        this.actionName = 'UserDefaultInfo/Details';        
    }

    logout(){
        this.loginService.logoutAsync(true);
    }
    
    protected override async onProcessSaveSuccess() {

        this.isLoading = true;

        await this.loginService.refreshTokenAsync();
        
        const params = this.route.snapshot.queryParams['params'];

        var returnUrlInfo = params ? JSON.parse(params) : null;    

        const returnUrl = returnUrlInfo ? returnUrlInfo.returnUrl : '/';

        await this.navigator.navigate(returnUrl, null, { replaceUrl: true });
    }
}
